
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../node_modules/vue-loader/lib/style-rewriter?{\"id\":\"data-v-006d85a5\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SidebarToggle.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./SidebarToggle.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-006d85a5\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SidebarToggle.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarToggle.vue
// module id = 93
// module chunks = 0